import { gql } from '__generated__';

export default gql(`
  mutation EditBackendTeam($input: EditTeamInput!) {
    editTeam(input: $input) {
      ...TeamFieldsFragment
    }
  }
`);
